/// <amd-module name="Build/DesignerExtensions/YamlSnippetForm/Components/SnippetInputGroup" />
import * as React from "react";

import { IAccordionSection } from "VSSUI/Accordion";

import { SnippetInput } from "Build/DesignerExtensions/YamlSnippetForm/Components/SnippetInput";
import { IServiceConnectionProvider } from "Build/DesignerExtensions/YamlAssistantLibrary/Contracts/Types";
import { TaskGroupDefinition } from "DistributedTask/Client/Contracts/TaskAgent";
import { YamlSnippetInput } from "Pipelines/Common/Library/Contracts/DataProvider";
import { ObservableValue } from "VSS/Core/Observable";
import { css } from "VSSUI/Util";

export interface ISnippetInputValueProvider {
    getValue(name: string): string;
    setValue(name: string, value: string, valueAlias?: string): void;
    isVisible(name: string): boolean;
}

export interface SnippetInputListProps {
    className?: string;
    inputs: YamlSnippetInput[];
    inputValueProvider: ISnippetInputValueProvider;
    serviceConnectionProvider: IServiceConnectionProvider;
    onError(location: string, error: Error): void;
}

export class SnippetInputList extends React.Component<SnippetInputListProps, {}> {
    public render(): JSX.Element {
        return <div className={css("snippet-input-group flex-column", this.props.className)}>
            {this.props.inputs.map(i => <SnippetInput
                key={i.name} 
                snippetInput={i}
                isVisible={this.props.inputValueProvider.isVisible(i.name)}
                onValueChanged={this.props.inputValueProvider.setValue}
                getValue={this.props.inputValueProvider.getValue}
                serviceConnectionProvider={this.props.serviceConnectionProvider}
                onError={this.props.onError} />)}
        </div>;
    }
}

export class SnippetInputGroup implements IAccordionSection {
    constructor(private groupKey: string,
                private groupTitle: string | undefined,
                public isCollapsed: ObservableValue<boolean>,
                private inputs: YamlSnippetInput[],
                private inputValueProvider: ISnippetInputValueProvider,
                private serviceConnectionProvider: IServiceConnectionProvider,
                private onError: (location: string, error: Error) => void) { }

    public get key(): string {
        return this.groupKey;
    }

    public get title(): string | undefined {
        return this.groupTitle;
    }

    public onRenderContent(): JSX.Element {
        return <SnippetInputList 
            inputs={this.inputs} 
            inputValueProvider={this.inputValueProvider} 
            serviceConnectionProvider={this.serviceConnectionProvider}
            onError={this.onError} />
    }
}

export function getSnippetInputGroups(inputsByGroup: { [key: string]: YamlSnippetInput[] }, 
                                      groups: TaskGroupDefinition[],
                                      isGroupCollapsed: (groupName: string) => ObservableValue<boolean>,
                                      valueProvider: ISnippetInputValueProvider, 
                                      connectionProvider: IServiceConnectionProvider,
                                      onError: (location:string, error: Error) => void): SnippetInputGroup[] {
    const inputGroups: SnippetInputGroup[] = [];

    groups.forEach((groupDefinition: TaskGroupDefinition) => {
        inputGroups.push(new SnippetInputGroup(groupDefinition.name, 
                                            groupDefinition.displayName,
                                            isGroupCollapsed(groupDefinition.name),
                                            inputsByGroup[groupDefinition.name], 
                                            valueProvider, 
                                            connectionProvider,
                                            onError));
    });

    return inputGroups;
}
